import { clsx as t } from "clsx";
import { twMerge as o } from "tailwind-merge";
function i(...r) {
  return o(t(r));
}
export {
  i as cn
};
